import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { apiCall } from "../lib/apiClient";

/**
 * useAdminZones — stabilní seznam 3 klientských zón (S0/S1/S2 per DEC-009) pro
 * filtry v admin UI. Zdroj: GET /api/admin/sync/state (globalAdmin only, princip
 * #6). Na rozdíl od odvození zón z řádků dokumentů vrací vždy kompletní seznam,
 * nezávisle na aktivním filtru — dropdown tak nikdy nezkolabuje na 1 položku.
 */

const ZoneState = z.object({
  zone_id: z.string().uuid(),
  zone_code: z.string(),
});
const SyncStateResponse = z.object({
  zones: z.array(ZoneState),
});

export interface AdminZoneOption {
  zoneId: string;
  zoneCode: string;
}

export function useAdminZones() {
  return useQuery({
    queryKey: ["admin", "zones"] as const,
    queryFn: async (): Promise<AdminZoneOption[]> => {
      const raw = await apiCall<unknown>("/api/admin/sync/state");
      const parsed = SyncStateResponse.parse(raw);
      return parsed.zones
        .map((z) => ({ zoneId: z.zone_id, zoneCode: z.zone_code }))
        .sort((a, b) => a.zoneCode.localeCompare(b.zoneCode));
    },
    staleTime: 5 * 60_000,
  });
}
